module.exports = __webpack_public_path__ + "img/icon-Instagram_square.b7c05771.png";